/* eslint-disable */
import axios from "axios";
import '../utils/axios.interceptor';
import { format } from "date-fns";
import { urlCoreBack } from "../../project/configs/config";

const epName = "v1/gestion-comercial/";
const nameItemsText = "Gestión de Atención";
const nameItemText = "Gestión de Atención";
const itemGender = "F";
const elLa = itemGender === "M" ? "el" : "la";
const unUna = itemGender === "M" ? "un" : "una";
//
// #############################################################################
//
export const getGestionAtencion = async (parIdGestionAtencion) => {
	let _errorMessage = "Se produjo un error al obtener la Gestión de Atencion";

	try {
		const response = await axios({
			method: "GET",
			url: `${urlCoreBack}${epName}`,
			params: { id: parIdGestionAtencion },
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			let _errCode = response.data?.error_code || response.data?.code || '';
			let _errorToken = _errCode.startsWith('err-access-token') || _errCode === 'err-token-not-received';
			if (!_error && !_errorToken) {
				// si no hay error controlado
				response.ok = true;
				return response;
			}
		}

		// si hay algun error controlado

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};
//
// #############################################################################
//
export const getGestionesAtencion = async (params) => {
	let _params = {};
	let _errorMessage = "Se produjo un error al obtener Gestiones de Atención";

	if (params.codigo) {
		_params.codigo = params.codigo;
	}

	if (params.documento) {
		_params.num_doc = params.documento;
	}

	if (params.nombre) {
		_params.nombre = params.nombre;
	}

	if (params.apellido) {
		_params.apellido = params.apellido;
	}

	if (params.sucursal) {
		_params.id_area = params.sucursal;
	}

	if (params.usuario) {
		_params.id_usuario = params.usuario;
	}

	if (params.fechaCreacionDesde) {
		_params.fecha_creacion_desde = format(params.fechaCreacionDesde, "yyyy/MM/dd");
	}

	if (params.fechaCreacionHasta) {
		_params.fecha_creacion_hasta = format(params.fechaCreacionHasta, "yyyy/MM/dd");
	}

	if (params.estadoActual) {
		_params.estado_actual = params.estadoActual;
	}

	if (params.particularOSocial) {
		_params.particular_osocial = params.particularOSocial;
	}

	if ('rows' in params) {
		_params.rows = params.rows;
	}

	if ('first' in params) {
		_params.first = params.first;
	}

	try {
		const response = await axios({
			method: "GET",
			url: `${urlCoreBack}${epName}`,
			params: _params,
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			let _errCode = response.data?.error_code || response.data?.code || '';
			let _errorToken = _errCode.startsWith('err-access-token') || _errCode === 'err-token-not-received';
			if (!_error && !_errorToken) {
				// si no hay error controlado
				response.ok = true;
				return response;
			}
		}

		// si hay algun error controlado

		console.log(_errorMessage);
		console.log(response);
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};
//
// #############################################################################
//
export const saveGestionAtencion = async (actionCrud, gestionAtencion) => {
	let _errorMessage = `No fue posible guardar ${elLa} ${nameItemText}`;

	gestionAtencion.id_area = localStorage.getItem("id_area_ventas");
	gestionAtencion.id_usuario = localStorage.getItem("id_usuario");

	try {
		let response = {};
		if (actionCrud === "new") {
			response = await axios({
				method: "POST",
				url: `${urlCoreBack}${epName}`,
				data: gestionAtencion,
			});
		} else if (actionCrud === "update") {
			response = await axios({
				method: "PUT",
				url: `${urlCoreBack}${epName}`,
				data: gestionAtencion,
			});
		}

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";

			if (!_error) {
				response.ok = true;
				response.messageText = `${nameItemText} guardada`;
				response.messageSeverity = "success";
				return response;
			}

			if (response.data.code === "err-gc-not-editable") {
				response.ok = false;
				response.messageText = "No es posible editar la Gestión de Atención";
				response.messageSeverity = "error";
				return response;
			}

			if (response.data.code === "err-gc-numero-cuit-cuil-invalid") {
				response.ok = false;
				response.messageText = "El número de CUIT/CUIL ingresado no es válido";
				response.messageSeverity = "error";
				return response;
			}

			if (response.data.code === "err-gc-not-cantidad-disponible" || response.data.code === "err-gc-not-cantidad-disponible-in-area") {
				response.ok = false;
				response.messageText = "Al menos un artículo ya no tiene cantidad disponible";
				response.messageSeverity = "error";
				return response;
			}
		}

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;

	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};
//
// #############################################################################
//
export const gcConfirmaAProduccion = async (parIdGestionAtencion, parIdGesionAtencionAnteojo, parIdGestionAtencionArreglo) => {
	let _errorMessage = `No fue posible confirmar el envío a producción`;

	let _epName = "v1/confirma-produccion/";

	let _params = {
		id_gc: parIdGestionAtencion,
		id_gc_anteojo: parIdGesionAtencionAnteojo,
		id_gc_arreglo: parIdGestionAtencionArreglo,
		id_area: localStorage.getItem("id_area_ventas"),
		id_usuario: localStorage.getItem("id_usuario"),
	}

	try {
		let response = await axios({
			method: "PUT",
			url: `${urlCoreBack}${_epName}`,
			data: _params,
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";

			if (!_error) {
				response.ok = true;
				let _messageText = parIdGestionAtencion ? "Gestión de Atención confirmada a producción" : parIdGesionAtencionAnteojo ? "Anteojo confirmado a producción" : "Arreglo confirmado a producción";
				response.messageText = _messageText;
				response.messageSeverity = "success";
				return response;
			}
		}

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;

	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};
//
// #############################################################################
//
export const getAnteojo = async (parIdGestionAtencionAnteojo) => {
	let _errorMessage = `No fue posible confirmar el envío a producción`;
	let _epName = "v1/anteojos/";

	let _params = {
		id: parIdGestionAtencionAnteojo,
		tipo_respuesta: "original",
		estados: "s"
	};

	try {
		const response = await axios({
			method: "GET",
			url: `${urlCoreBack}${_epName}`,
			params: _params,
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			let _errCode = response.data?.error_code || response.data?.code || '';
			let _errorToken = _errCode.startsWith('err-access-token') || _errCode === 'err-token-not-received';
			if (!_error && !_errorToken) {
				// si no hay error controlado
				response.ok = true;
				return response;
			}
		}

		// si hay algun error controlado

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};
//
// #############################################################################
//
export const getArreglo = async (parIdGestionAtencionArreglo) => {
	let _errorMessage = `No fue posible confirmar el envío a producción`;
	let _epName = "v1/arreglos/";

	let _params = {
		id: parIdGestionAtencionArreglo,
		tipo_respuesta: "original",
		estados: "s"
	};

	try {
		const response = await axios({
			method: "GET",
			url: `${urlCoreBack}${_epName}`,
			params: _params,
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			let _errCode = response.data?.error_code || response.data?.code || '';
			let _errorToken = _errCode.startsWith('err-access-token') || _errCode === 'err-token-not-received';
			if (!_error && !_errorToken) {
				// si no hay error controlado
				response.ok = true;
				return response;
			}
		}

		// si hay algun error controlado

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};
